"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripUserAndWorkspaceProps = void 0;
var tslib_1 = require("tslib");
/**
 * Given an object with settings that include user and workspace information, convert to a new object that
 * contains just the settings.
 *
 * @param userWorkspaceSettings - full object to strip of extra user and workspace data
 */
function stripUserAndWorkspaceProps(userWorkspaceSettings) {
    var _userId = userWorkspaceSettings.userId, _locale = userWorkspaceSettings.locale, _separators = userWorkspaceSettings.separators, _workspace = userWorkspaceSettings.workspace, rest = tslib_1.__rest(userWorkspaceSettings, ["userId", "locale", "separators", "workspace"]);
    return rest;
}
exports.stripUserAndWorkspaceProps = stripUserAndWorkspaceProps;
//# sourceMappingURL=conversion.js.map